import React, { ReactElement } from 'react';
import { Navigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

interface Props {
  children: ReactElement;
}

const PrivateRoute: React.FC<Props> = ({ children }) => {
  //todo Replace auth condition
  const [searchParams] = useSearchParams();
  const pgc = searchParams.get('pgc');
  const hasPgc = searchParams.has('pgc');
  const isAuthenticated = localStorage.getItem('access_token');
  const firstPgc = localStorage.getItem('pgc');
  if (!hasPgc) return <Navigate to={`/not-found`} />;
  if (firstPgc !== pgc) {
    window.localStorage.clear();
    return <Navigate to={`/login?pgc=${pgc}`} />;
  }
  return isAuthenticated ? children : <Navigate to={`/login?pgc=${pgc}`} />;
};

export default PrivateRoute;
